import React, { memo } from "react";
import ResultGridItemComponent from "@scenes/searchResults/ResultGridItemComponent";
import ResultListComponent from "@scenes/searchResults/ResultListItemComponent";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

const ListItem = ({
  index,
  item,
  selectedViewType,
  menuOptionSelected,
  menuOptions,
  checkBoxSelectionUpdate,
  productType,
  handleItemClick,
  favoriteFunctionClicked,
  isSelected,
  columnCount,
  xOffset,
  isFilterVisible,
  isBusinessPlan,
  inCart,
  showAvailabilityDot,
  displayRetailPrice,
  customizeColumnParams,
  userCurrency,
  productPrefix,
  sectionName,
  handleLinkClick,
}: any) => {
  const isGridView = selectedViewType === SearchResultsAndFavoritesEnum.GRID;
  if (item === null) return <EmptyView columnCount={columnCount} />;

  const commonProps = {
    isSelected,
    menuOptionSelected,
    menuOptions,
    checkBoxSelectionUpdate,
    productType,
    handleItemClick,
    favoriteFunctionClicked,
    columnCount,
    inCart,
    showAvailabilityDot,
    displayRetailPrice,
    userCurrency,
    productPrefix,
    isFilterVisible,
    sectionName,
    handleLinkClick,
  };

  if (isGridView) {
    return (
      <Parent>
        <ResultGridItemComponent xItem={item} mIndex={index} {...commonProps} />
      </Parent>
    );
  }

  return (
    <ResultListComponent
      yItem={item}
      index={index}
      isCustomApp={isBusinessPlan}
      selectedViewType={selectedViewType}
      xOffset={xOffset}
      isFilterVisible={isFilterVisible}
      customizeColumnParams={customizeColumnParams}
      {...commonProps}
    />
  );
};

const EmptyView = styled.View<any>`
  flex: ${({ columnCount }) => 1 / columnCount};
`;

const Parent = styled.View<any>`
  width: 100%;
  padding: ${SpaceType.Basic}px;
`;

export default memo(ListItem, (prevProps, nextProps) => {
  return (
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.isFavorite === nextProps.isFavorite &&
    prevProps.inCart === nextProps.inCart &&
    prevProps.collectionCount === nextProps.collectionCount &&
    prevProps.customizeColumnParams === nextProps.customizeColumnParams &&
    prevProps.isFilterVisible === nextProps.isFilterVisible &&
    prevProps.item?.id === nextProps.item?.id &&
    prevProps.item?.image_thumb_url === nextProps.item?.image_thumb_url &&
    prevProps.item?.image_url === nextProps.item?.image_url &&
    prevProps.item?.video_url === nextProps.item?.video_url &&
    prevProps.selectedViewType === nextProps.selectedViewType &&
    prevProps.showAvailabilityDot === nextProps.showAvailabilityDot &&
    prevProps.sectionName === nextProps.sectionName &&
    prevProps.handleLinkClick === nextProps.handleLinkClick &&
    prevProps.menuOptions === nextProps.menuOptions
  );
});
